import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('lokakaryaPa', {
      mInstrumen: (state) => state.instrumen || {},
    }),

    keySchema() {
      const keys = Object.keys(this.mInstrumen);
      return keys[0] || '';
    },

    schema() {
      const schemas = {
        'nyata68-komunitas1': this.nyata68Komunitas1,
        'nyata68-komunitas2': this.nyata68Komunitas2,
        'cerita68-komunitas1': this.cerita68Komunitas1,
        'cerita68-komunitas2': this.cerita68Komunitas2,
        'nyata69-data': this.nyata69Data,
        'nyata69-literasi': this.nyata69Literasi,
        'nyata69-disiplin': this.nyata69Disiplin,
        'cerita69-data': this.cerita69Data,
        'cerita69-literasi': this.cerita69Literasi,
        'cerita69-disiplin': this.cerita69Disiplin,
        'nyata90-asesmen': this.nyata90Asesmen,
        'nyata90-pancasila': this.nyata90Pancasila,
        'cerita90-asesmen': this.cerita90Asesmen,
        'cerita90-pancasila': this.cerita90Pancasila,
        'nyata91-data': this.nyata91Data,
        'nyata91-disiplin': this.nyata91Disiplin,
        'cerita91-data': this.cerita91Data,
        'cerita91-disiplin': this.cerita91Disiplin,
        'nyata92-komunitas1': this.nyata92Komunitas1,
        'nyata92-komunitas2': this.nyata92Komunitas2,
        'cerita92-komunitas1': this.cerita92Komunitas1,
        'cerita92-komunitas2': this.cerita92Komunitas2,
        'nyata93-pimpinan1': this.nyata93Pimpinan1,
        'nyata93-pimpinan2': this.nyata93Pimpinan2,
        'cerita93-pimpinan1': this.cerita93Pimpinan1,
        'cerita93-pimpinan2': this.cerita93Pimpinan2,
        'nyata110-belajar1': this.nyata110Belajar1,
        'nyata110-belajar2': this.nyata110Belajar2,
        'cerita110-belajar1': this.cerita110Belajar1,
        'cerita110-belajar2': this.cerita110Belajar2,
        'nyata111-data': this.nyata111Data,
        'nyata111-disiplin': this.nyata111Disiplin,
        'cerita111-data': this.cerita111Data,
        'cerita111-disiplin': this.cerita111Disiplin,
        'nyata112-komunitas1': this.nyata112Komunitas1,
        'nyata112-komunitas2': this.nyata112Komunitas2,
        'cerita112-komunitas1': this.cerita112Komunitas1,
        'cerita112-komunitas2': this.cerita112Komunitas2,
        'ds24-aksi': this.ds24Instrumen,
        'ds24-satpen': this.ds24Instrumen,
      };

      return schemas[this.keySchema];
    },

    infoLokakarya() {
      const schemas = {
        'nyata68-komunitas1': 'Komunitas Belajar 1',
        'nyata68-komunitas2': 'Komunitas Belajar 2',
        'cerita68-komunitas1': 'Komunitas Belajar 1',
        'cerita68-komunitas2': 'Komunitas Belajar 2',
        'nyata69-data': 'Perencanaan Berbasis Data',
        'nyata69-literasi': 'Penguatan Literasi',
        'nyata69-disiplin': 'Disiplin Positif',
        'cerita69-data': 'Perencanaan Berbasis Data',
        'cerita69-literasi': 'Penguatan Literasi',
        'cerita69-disiplin': 'Disiplin Positif',
        'nyata90-asesmen': 'Pembelajaran dan Asesmen',
        'nyata90-pancasila': 'Projek Penguatan Profil Pelajar Pancasila',
        'cerita90-asesmen': 'Pembelajaran dan Asesmen',
        'cerita90-pancasila': 'Projek Penguatan Profil Pelajar dan Pancasila',
        'nyata91-data': 'Perencanaan Berbasis Data',
        'nyata91-disiplin': 'Disiplin Positif',
        'cerita91-data': 'Perencanaan Berbasis Data',
        'cerita91-disiplin': 'Disiplin Positif',
        'nyata92-komunitas1': 'Komunitas belajar 1',
        'nyata92-komunitas2': 'Komunitas belajar 2',
        'cerita92-komunitas1': 'Komunitas belajar 1',
        'cerita92-komunitas2': 'Komunitas belajar 2',
        'nyata93-pimpinan1': 'Kepemimpinan Sekolah 1',
        'nyata93-pimpinan2': 'Kepemimpinan Sekolah 2',
        'cerita93-pimpinan1': 'Kepemimpinan Sekolah 1',
        'cerita93-pimpinan2': 'Kepemimpinan Sekolah 2',
        'nyata110-belajar1': 'Perencanaan Pembelajaran 1',
        'nyata110-belajar2': 'Perencanaan Pembelajaran 2',
        'cerita110-belajar1': 'Perencanaan Pembelajaran 1',
        'cerita110-belajar2': 'Perencanaan Pembelajaran 2',
        'nyata111-data': 'Perencanaan Berbasis Data',
        'nyata111-disiplin': 'Disiplin Positif',
        'cerita111-data': 'Perencanaan Berbasis Data',
        'cerita111-disiplin': 'Disiplin Positif',
        'nyata112-komunitas1': 'Komunitas belajar 1',
        'nyata112-komunitas2': 'Komunitas belajar 2',
        'cerita112-komunitas1': 'Komunitas belajar 1',
        'cerita112-komunitas2': 'Komunitas belajar 2',
        'ds24-aksi': this.$getDeepObj(this.lokakarya, 'm_lokakarya_kegiatan_psp.keterangan'),
        'ds24-satpen': this.$getDeepObj(this.lokakarya, 'm_lokakarya_kegiatan_psp.keterangan'),
      };

      return [
        {
          type: 'textView',
          label: 'Nama Sekolah',
          labelColor: 'indigo',
          bgColor: 'grey lighten-3 pa-2 mb-4',
          value: this.$getDeepObj(this.detail, `sekolah.nama`) || '',
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'textView',
          label: 'Lokakarya',
          labelColor: 'indigo',
          bgColor: 'grey lighten-3 pa-2 mb-4',
          value: schemas[this.keySchema],
          grid: { cols: 12, md: 6 },
        },
      ];
    },

    nyata68Komunitas1() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['nyata68-komunitas1'] || []).map((instrumen) => {
          if (+instrumen.id === 102) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-101`] === 412 } });
          } else if ([105, 106].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-101`] === 411 } });
          } else if (![101, 105, 106].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, {
              exist: { status: +this.form[`instrumen-radio-101`] === 411 && +this.form[`instrumen-radio-106`] === 891 },
            });
          }

          return instrumen;
        }),
      ];
    },

    nyata68Komunitas2() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['nyata68-komunitas2'] || []).map((instrumen) => {
          if (+instrumen.id === 112) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-111`] === 432 } });
          } else if ([115, 116].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-111`] === 431 } });
          } else if (![111, 115, 116].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, {
              exist: { status: +this.form[`instrumen-radio-111`] === 431 && +this.form[`instrumen-radio-116`] === 901 },
            });
          }

          return instrumen;
        }),
      ];
    },

    cerita68Komunitas1() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['cerita68-komunitas1'] || []).map((instrumen) => {
          if (+instrumen.id >= 121 && +instrumen.id <= 124) {
            if (+instrumen.id === 122) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-121`] === 452 } });
            } else if (+instrumen.id !== 121) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-121`] === 451 } });
            }
          } else if (+instrumen.id >= 125 && +instrumen.id <= 128) {
            if (+instrumen.id === 126) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-125`] === 472 } });
            } else if (+instrumen.id !== 125) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-125`] === 471 } });
            }
          } else if (+instrumen.id >= 129 && +instrumen.id <= 132) {
            if (+instrumen.id === 130) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-129`] === 492 } });
            } else if (+instrumen.id !== 129) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-129`] === 491 } });
            }
          }

          return instrumen;
        }),
      ];
    },

    cerita68Komunitas2() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['cerita68-komunitas2'] || []).map((instrumen) => {
          if (+instrumen.id >= 141 && +instrumen.id <= 144) {
            if (+instrumen.id === 142) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-141`] === 512 } });
            } else if (+instrumen.id !== 141) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-141`] === 511 } });
            }
          } else if (+instrumen.id >= 145 && +instrumen.id <= 148) {
            if (+instrumen.id === 146) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-145`] === 532 } });
            } else if (+instrumen.id !== 145) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-145`] === 531 } });
            }
          } else if (+instrumen.id >= 149 && +instrumen.id <= 152) {
            if (+instrumen.id === 150) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-149`] === 552 } });
            } else if (+instrumen.id !== 149) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-149`] === 551 } });
            }
          }

          return instrumen;
        }),
      ];
    },

    nyata69Data() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['nyata69-data'] || []).map((instrumen) => {
          if (+instrumen.id === 1312) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1311`] === 1312 } });
          } else if ([1315, 1316].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1311`] === 1311 } });
          } else if (![1311, 1315, 1316].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, {
              exist: {
                status: +this.form[`instrumen-radio-1311`] === 1311 && +this.form[`instrumen-radio-1316`] === 1331,
              },
            });
          }

          return instrumen;
        }),
      ];
    },

    nyata69Literasi() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['nyata69-literasi'] || []).map((instrumen) => {
          if (+instrumen.id === 1322) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1321`] === 1342 } });
          } else if ([1325, 1326].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1321`] === 1341 } });
          } else if (![1321, 1325, 1326].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, {
              exist: {
                status: +this.form[`instrumen-radio-1321`] === 1341 && +this.form[`instrumen-radio-1326`] === 1361,
              },
            });
          }

          return instrumen;
        }),
      ];
    },

    nyata69Disiplin() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['nyata69-disiplin'] || []).map((instrumen) => {
          if (+instrumen.id === 1332) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1331`] === 1372 } });
          } else if ([1335, 1336].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1331`] === 1371 } });
          } else if (![1331, 1335, 1336].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, {
              exist: {
                status: +this.form[`instrumen-radio-1331`] === 1371 && +this.form[`instrumen-radio-1336`] === 1391,
              },
            });
          }

          return instrumen;
        }),
      ];
    },

    cerita69Data() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['cerita69-data'] || []).map((instrumen) => {
          if (+instrumen.id >= 1341 && +instrumen.id <= 1344) {
            if (+instrumen.id === 1342) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1341`] === 1402 } });
            } else if (+instrumen.id !== 1341) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1341`] === 1401 } });
            }
          } else if (+instrumen.id >= 1345 && +instrumen.id <= 1348) {
            if (+instrumen.id === 1346) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1345`] === 1422 } });
            } else if (+instrumen.id !== 1345) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1345`] === 1421 } });
            }
          } else if (+instrumen.id >= 1349 && +instrumen.id <= 1352) {
            if (+instrumen.id === 1350) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1349`] === 1442 } });
            } else if (+instrumen.id !== 1349) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1349`] === 1441 } });
            }
          }

          return instrumen;
        }),
      ];
    },

    cerita69Literasi() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['cerita69-literasi'] || []).map((instrumen) => {
          if (+instrumen.id >= 1361 && +instrumen.id <= 1364) {
            if (+instrumen.id === 1362) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1361`] === 1462 } });
            } else if (+instrumen.id !== 1361) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1361`] === 1461 } });
            }
          } else if (+instrumen.id >= 1365 && +instrumen.id <= 1368) {
            if (+instrumen.id === 1366) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1365`] === 1482 } });
            } else if (+instrumen.id !== 1365) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1365`] === 1481 } });
            }
          } else if (+instrumen.id >= 1369 && +instrumen.id <= 1372) {
            if (+instrumen.id === 1370) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1369`] === 1502 } });
            } else if (+instrumen.id !== 1369) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1369`] === 1501 } });
            }
          }

          return instrumen;
        }),
      ];
    },

    cerita69Disiplin() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['cerita69-disiplin'] || []).map((instrumen) => {
          if (+instrumen.id >= 1381 && +instrumen.id <= 1384) {
            if (+instrumen.id === 1382) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1381`] === 1522 } });
            } else if (+instrumen.id !== 1381) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1381`] === 1521 } });
            }
          } else if (+instrumen.id >= 1385 && +instrumen.id <= 1388) {
            if (+instrumen.id === 1386) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1385`] === 1542 } });
            } else if (+instrumen.id !== 1385) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1385`] === 1541 } });
            }
          } else if (+instrumen.id >= 1389 && +instrumen.id <= 1392) {
            if (+instrumen.id === 1390) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1389`] === 1562 } });
            } else if (+instrumen.id !== 1389) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1389`] === 1561 } });
            }
          }

          return instrumen;
        }),
      ];
    },

    nyata90Asesmen() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['nyata90-asesmen'] || []).map((instrumen) => {
          if (+instrumen.id === 162) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-161`] === 572 } });
          } else if ([165, 166].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-161`] === 571 } });
          } else if (![161, 165, 166].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, {
              exist: { status: +this.form[`instrumen-radio-161`] === 571 && +this.form[`instrumen-radio-166`] === 911 },
            });
          }

          return instrumen;
        }),
      ];
    },

    nyata90Pancasila() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['nyata90-pancasila'] || []).map((instrumen) => {
          if (+instrumen.id === 172) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-171`] === 592 } });
          } else if ([175, 176].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-171`] === 591 } });
          } else if (![171, 175, 176].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, {
              exist: { status: +this.form[`instrumen-radio-171`] === 591 && +this.form[`instrumen-radio-176`] === 921 },
            });
          }

          return instrumen;
        }),
      ];
    },

    cerita90Asesmen() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['cerita90-asesmen'] || []).map((instrumen) => {
          if (+instrumen.id >= 181 && +instrumen.id <= 184) {
            if (+instrumen.id === 182) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-181`] === 612 } });
            } else if (+instrumen.id !== 181) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-181`] === 611 } });
            }
          } else if (+instrumen.id >= 185 && +instrumen.id <= 188) {
            if (+instrumen.id === 186) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-185`] === 632 } });
            } else if (+instrumen.id !== 185) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-185`] === 631 } });
            }
          } else if (+instrumen.id >= 189 && +instrumen.id <= 192) {
            if (+instrumen.id === 190) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-189`] === 652 } });
            } else if (+instrumen.id !== 189) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-189`] === 651 } });
            }
          }

          return instrumen;
        }),
      ];
    },

    cerita90Pancasila() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['cerita90-pancasila'] || []).map((instrumen) => {
          if (+instrumen.id >= 201 && +instrumen.id <= 204) {
            if (+instrumen.id === 202) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-201`] === 672 } });
            } else if (+instrumen.id !== 201) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-201`] === 671 } });
            }
          } else if (+instrumen.id >= 205 && +instrumen.id <= 208) {
            if (+instrumen.id === 206) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-205`] === 692 } });
            } else if (+instrumen.id !== 205) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-205`] === 691 } });
            }
          } else if (+instrumen.id >= 209 && +instrumen.id <= 212) {
            if (+instrumen.id === 210) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-209`] === 712 } });
            } else if (+instrumen.id !== 209) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-209`] === 711 } });
            }
          }

          return instrumen;
        }),
      ];
    },

    nyata91Data() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['nyata91-data'] || []).map((instrumen) => {
          if (+instrumen.id === 302) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-301`] === 952 } });
          } else if ([305, 306].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-301`] === 951 } });
          } else if (![301, 305, 306].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, {
              exist: { status: +this.form[`instrumen-radio-301`] === 951 && +this.form[`instrumen-radio-306`] === 971 },
            });
          }

          return instrumen;
        }),
      ];
    },

    nyata91Disiplin() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['nyata91-disiplin'] || []).map((instrumen) => {
          if (+instrumen.id === 312) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-311`] === 982 } });
          } else if ([315, 316].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-311`] === 981 } });
          } else if (![311, 315, 316].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, {
              exist: {
                status: +this.form[`instrumen-radio-311`] === 981 && +this.form[`instrumen-radio-316`] === 1001,
              },
            });
          }

          return instrumen;
        }),
      ];
    },

    cerita91Data() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['cerita91-data'] || []).map((instrumen) => {
          if (+instrumen.id >= 321 && +instrumen.id <= 324) {
            if (+instrumen.id === 322) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-321`] === 1012 } });
            } else if (+instrumen.id !== 321) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-321`] === 1011 } });
            }
          } else if (+instrumen.id >= 325 && +instrumen.id <= 328) {
            if (+instrumen.id === 326) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-325`] === 1032 } });
            } else if (+instrumen.id !== 325) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-325`] === 1031 } });
            }
          } else if (+instrumen.id >= 329 && +instrumen.id <= 332) {
            if (+instrumen.id === 330) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-329`] === 1052 } });
            } else if (+instrumen.id !== 329) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-329`] === 1051 } });
            }
          }

          return instrumen;
        }),
      ];
    },

    cerita91Disiplin() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['cerita91-disiplin'] || []).map((instrumen) => {
          if (+instrumen.id >= 341 && +instrumen.id <= 344) {
            if (+instrumen.id === 342) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-341`] === 1072 } });
            } else if (+instrumen.id !== 341) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-341`] === 1071 } });
            }
          } else if (+instrumen.id >= 345 && +instrumen.id <= 348) {
            if (+instrumen.id === 346) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-345`] === 1092 } });
            } else if (+instrumen.id !== 345) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-345`] === 1091 } });
            }
          } else if (+instrumen.id >= 349 && +instrumen.id <= 352) {
            if (+instrumen.id === 350) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-349`] === 1112 } });
            } else if (+instrumen.id !== 349) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-349`] === 1111 } });
            }
          }

          return instrumen;
        }),
      ];
    },

    nyata92Komunitas1() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['nyata92-komunitas1'] || []).map((instrumen) => {
          if (+instrumen.id === 1402) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1401`] === 1582 } });
          } else if ([1405, 1406].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1401`] === 1581 } });
          } else if (![1401, 1405, 1406].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, {
              exist: {
                status: +this.form[`instrumen-radio-1401`] === 1581 && +this.form[`instrumen-radio-1406`] === 1601,
              },
            });
          }

          return instrumen;
        }),
      ];
    },

    nyata92Komunitas2() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['nyata92-komunitas2'] || []).map((instrumen) => {
          if (+instrumen.id === 1412) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1411`] === 1612 } });
          } else if ([1415, 1416].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1411`] === 1611 } });
          } else if (![1411, 1415, 1416].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, {
              exist: {
                status: +this.form[`instrumen-radio-1411`] === 1611 && +this.form[`instrumen-radio-1416`] === 1631,
              },
            });
          }

          return instrumen;
        }),
      ];
    },

    cerita92Komunitas1() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['cerita92-komunitas1'] || []).map((instrumen) => {
          if (+instrumen.id >= 1421 && +instrumen.id <= 1424) {
            if (+instrumen.id === 1422) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1421`] === 1642 } });
            } else if (+instrumen.id !== 1421) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1421`] === 1641 } });
            }
          } else if (+instrumen.id >= 1425 && +instrumen.id <= 1428) {
            if (+instrumen.id === 1426) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1425`] === 1662 } });
            } else if (+instrumen.id !== 1425) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1425`] === 1661 } });
            }
          } else if (+instrumen.id >= 1429 && +instrumen.id <= 1432) {
            if (+instrumen.id === 1430) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1429`] === 1682 } });
            } else if (+instrumen.id !== 1429) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1429`] === 1681 } });
            }
          }

          return instrumen;
        }),
      ];
    },

    cerita92Komunitas2() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['cerita92-komunitas2'] || []).map((instrumen) => {
          if (+instrumen.id >= 1441 && +instrumen.id <= 1444) {
            if (+instrumen.id === 1442) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1441`] === 1702 } });
            } else if (+instrumen.id !== 1441) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1441`] === 1701 } });
            }
          } else if (+instrumen.id >= 1445 && +instrumen.id <= 1448) {
            if (+instrumen.id === 1446) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1445`] === 1722 } });
            } else if (+instrumen.id !== 1445) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1445`] === 1721 } });
            }
          } else if (+instrumen.id >= 1449 && +instrumen.id <= 1452) {
            if (+instrumen.id === 1450) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1449`] === 1742 } });
            } else if (+instrumen.id !== 1449) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1449`] === 1741 } });
            }
          }

          return instrumen;
        }),
      ];
    },

    nyata93Pimpinan1() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['nyata93-pimpinan1'] || []).map((instrumen) => {
          if (+instrumen.id === 1522) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1521`] === 1942 } });
          } else if ([1525, 1526].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1521`] === 1941 } });
          } else if (![1521, 1525, 1526].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, {
              exist: {
                status: +this.form[`instrumen-radio-1521`] === 1941 && +this.form[`instrumen-radio-1526`] === 1961,
              },
            });
          }

          return instrumen;
        }),
      ];
    },

    nyata93Pimpinan2() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['nyata93-pimpinan2'] || []).map((instrumen) => {
          if (+instrumen.id === 1532) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1531`] === 1972 } });
          } else if ([1535, 1536].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1531`] === 1971 } });
          } else if (![1531, 1535, 1536].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, {
              exist: {
                status: +this.form[`instrumen-radio-1531`] === 1971 && +this.form[`instrumen-radio-1536`] === 1991,
              },
            });
          }

          return instrumen;
        }),
      ];
    },

    cerita93Pimpinan1() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['cerita93-pimpinan1'] || []).map((instrumen) => {
          if (+instrumen.id >= 1541 && +instrumen.id <= 1544) {
            if (+instrumen.id === 1542) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1541`] === 2002 } });
            } else if (+instrumen.id !== 1541) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1541`] === 2001 } });
            }
          } else if (+instrumen.id >= 1545 && +instrumen.id <= 1548) {
            if (+instrumen.id === 1546) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1545`] === 2022 } });
            } else if (+instrumen.id !== 1545) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1545`] === 2021 } });
            }
          } else if (+instrumen.id >= 1549 && +instrumen.id <= 1552) {
            if (+instrumen.id === 1550) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1549`] === 2042 } });
            } else if (+instrumen.id !== 1549) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1549`] === 2041 } });
            }
          }

          return instrumen;
        }),
      ];
    },

    cerita93Pimpinan2() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['cerita93-pimpinan2'] || []).map((instrumen) => {
          if (+instrumen.id >= 1561 && +instrumen.id <= 1564) {
            if (+instrumen.id === 1562) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1561`] === 2062 } });
            } else if (+instrumen.id !== 1561) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1561`] === 2061 } });
            }
          } else if (+instrumen.id >= 1565 && +instrumen.id <= 1568) {
            if (+instrumen.id === 1566) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1565`] === 2082 } });
            } else if (+instrumen.id !== 1565) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1565`] === 2081 } });
            }
          } else if (+instrumen.id >= 1569 && +instrumen.id <= 1572) {
            if (+instrumen.id === 1570) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1569`] === 2102 } });
            } else if (+instrumen.id !== 1569) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1569`] === 2101 } });
            }
          }

          return instrumen;
        }),
      ];
    },

    nyata110Belajar1() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['nyata110-belajar1'] || []).map((instrumen) => {
          if (+instrumen.id === 222) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-221`] === 732 } });
          } else if ([225, 226].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-221`] === 731 } });
          } else if (![221, 225, 226].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, {
              exist: { status: +this.form[`instrumen-radio-221`] === 731 && +this.form[`instrumen-radio-226`] === 931 },
            });
          }

          return instrumen;
        }),
      ];
    },

    nyata110Belajar2() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['nyata110-belajar2'] || []).map((instrumen) => {
          if (+instrumen.id === 232) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-231`] === 752 } });
          } else if ([235, 236].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-231`] === 751 } });
          } else if (![231, 235, 236].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, {
              exist: { status: +this.form[`instrumen-radio-231`] === 751 && +this.form[`instrumen-radio-236`] === 941 },
            });
          }

          return instrumen;
        }),
      ];
    },

    cerita110Belajar1() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['cerita110-belajar1'] || []).map((instrumen) => {
          if (+instrumen.id >= 241 && +instrumen.id <= 244) {
            if (+instrumen.id === 242) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-241`] === 772 } });
            } else if (+instrumen.id !== 241) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-241`] === 771 } });
            }
          } else if (+instrumen.id >= 245 && +instrumen.id <= 248) {
            if (+instrumen.id === 246) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-245`] === 792 } });
            } else if (+instrumen.id !== 245) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-245`] === 791 } });
            }
          } else if (+instrumen.id >= 249 && +instrumen.id <= 252) {
            if (+instrumen.id === 250) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-249`] === 812 } });
            } else if (+instrumen.id !== 249) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-249`] === 811 } });
            }
          }

          return instrumen;
        }),
      ];
    },

    cerita110Belajar2() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['cerita110-belajar2'] || []).map((instrumen) => {
          if (+instrumen.id >= 261 && +instrumen.id <= 264) {
            if (+instrumen.id === 262) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-261`] === 832 } });
            } else if (+instrumen.id !== 261) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-261`] === 831 } });
            }
          } else if (+instrumen.id >= 265 && +instrumen.id <= 268) {
            if (+instrumen.id === 266) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-265`] === 852 } });
            } else if (+instrumen.id !== 265) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-265`] === 851 } });
            }
          } else if (+instrumen.id >= 269 && +instrumen.id <= 272) {
            if (+instrumen.id === 270) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-269`] === 872 } });
            } else if (+instrumen.id !== 269) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-269`] === 871 } });
            }
          }

          return instrumen;
        }),
      ];
    },

    nyata111Data() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['nyata111-data'] || []).map((instrumen) => {
          if (+instrumen.id === 402) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-401`] === 1132 } });
          } else if ([405, 406].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-401`] === 1131 } });
          } else if (![401, 405, 406].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, {
              exist: {
                status: +this.form[`instrumen-radio-401`] === 1131 && +this.form[`instrumen-radio-406`] === 1151,
              },
            });
          }

          return instrumen;
        }),
      ];
    },

    nyata111Disiplin() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['nyata111-disiplin'] || []).map((instrumen) => {
          if (+instrumen.id === 412) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-411`] === 1162 } });
          } else if ([415, 416].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-411`] === 1161 } });
          } else if (![411, 415, 416].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, {
              exist: {
                status: +this.form[`instrumen-radio-411`] === 1161 && +this.form[`instrumen-radio-416`] === 1181,
              },
            });
          }

          return instrumen;
        }),
      ];
    },

    cerita111Data() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['cerita111-data'] || []).map((instrumen) => {
          if (+instrumen.id >= 421 && +instrumen.id <= 424) {
            if (+instrumen.id === 422) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-421`] === 1192 } });
            } else if (+instrumen.id !== 421) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-421`] === 1191 } });
            }
          } else if (+instrumen.id >= 425 && +instrumen.id <= 428) {
            if (+instrumen.id === 426) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-425`] === 1212 } });
            } else if (+instrumen.id !== 425) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-425`] === 1211 } });
            }
          } else if (+instrumen.id >= 429 && +instrumen.id <= 432) {
            if (+instrumen.id === 430) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-429`] === 1232 } });
            } else if (+instrumen.id !== 429) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-429`] === 1231 } });
            }
          }

          return instrumen;
        }),
      ];
    },

    cerita111Disiplin() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['cerita111-disiplin'] || []).map((instrumen) => {
          if (+instrumen.id >= 441 && +instrumen.id <= 444) {
            if (+instrumen.id === 442) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-441`] === 1252 } });
            } else if (+instrumen.id !== 441) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-441`] === 1251 } });
            }
          } else if (+instrumen.id >= 445 && +instrumen.id <= 448) {
            if (+instrumen.id === 446) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-445`] === 1272 } });
            } else if (+instrumen.id !== 445) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-445`] === 1271 } });
            }
          } else if (+instrumen.id >= 449 && +instrumen.id <= 452) {
            if (+instrumen.id === 450) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-449`] === 1292 } });
            } else if (+instrumen.id !== 449) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-449`] === 1291 } });
            }
          }

          return instrumen;
        }),
      ];
    },

    nyata112Komunitas1() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['nyata112-komunitas1'] || []).map((instrumen) => {
          if (+instrumen.id === 1462) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1461`] === 1762 } });
          } else if ([1465, 1466].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1461`] === 1761 } });
          } else if (![1461, 1465, 1466].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, {
              exist: {
                status: +this.form[`instrumen-radio-1461`] === 1761 && +this.form[`instrumen-radio-1466`] === 1781,
              },
            });
          }

          return instrumen;
        }),
      ];
    },

    nyata112Komunitas2() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['nyata112-komunitas2'] || []).map((instrumen) => {
          if (+instrumen.id === 1472) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1471`] === 1792 } });
          } else if ([1475, 1476].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1471`] === 1791 } });
          } else if (![1471, 1475, 1476].includes(+instrumen.id)) {
            return Object.assign({}, instrumen, {
              exist: {
                status: +this.form[`instrumen-radio-1471`] === 1791 && +this.form[`instrumen-radio-1476`] === 1811,
              },
            });
          }

          return instrumen;
        }),
      ];
    },

    cerita112Komunitas1() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['cerita112-komunitas1'] || []).map((instrumen) => {
          if (+instrumen.id >= 1481 && +instrumen.id <= 1484) {
            if (+instrumen.id === 1482) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1481`] === 1822 } });
            } else if (+instrumen.id !== 1481) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1481`] === 1821 } });
            }
          } else if (+instrumen.id >= 1485 && +instrumen.id <= 1488) {
            if (+instrumen.id === 1486) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1485`] === 1842 } });
            } else if (+instrumen.id !== 1485) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1485`] === 1841 } });
            }
          } else if (+instrumen.id >= 1489 && +instrumen.id <= 1492) {
            if (+instrumen.id === 1490) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1489`] === 1862 } });
            } else if (+instrumen.id !== 1489) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1489`] === 1861 } });
            }
          }

          return instrumen;
        }),
      ];
    },

    cerita112Komunitas2() {
      return [
        ...this.infoLokakarya,
        ...(this.instrumens['cerita112-komunitas2'] || []).map((instrumen) => {
          if (+instrumen.id >= 1501 && +instrumen.id <= 1504) {
            if (+instrumen.id === 1502) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1501`] === 1882 } });
            } else if (+instrumen.id !== 1501) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1501`] === 1881 } });
            }
          } else if (+instrumen.id >= 1505 && +instrumen.id <= 1508) {
            if (+instrumen.id === 1506) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1505`] === 1902 } });
            } else if (+instrumen.id !== 1505) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1505`] === 1901 } });
            }
          } else if (+instrumen.id >= 1509 && +instrumen.id <= 1512) {
            if (+instrumen.id === 1510) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1509`] === 1922 } });
            } else if (+instrumen.id !== 1509) {
              return Object.assign({}, instrumen, { exist: { status: +this.form[`instrumen-radio-1509`] === 1921 } });
            }
          }

          return instrumen;
        }),
      ];
    },

    ds24Instrumen() {
      return [...this.infoLokakarya, ...(this.instrumens[this.keyInstrumen] || [])];
    },
  },
};
